var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgForm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 84,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 118,
  height: 22,
  x: 1,
  y: 31,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeWidth: 2,
  rx: 7
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 118,
  height: 22,
  x: 1,
  y: 1.248,
  fill: "var(--hd-preview-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeWidth: 2,
  rx: 7
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 54,
  height: 24,
  x: 66,
  y: 59.752,
  fill: "var(--hop-neutral-surface-strong)",
  rx: 8
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 82,
  height: 4,
  x: 10.257,
  y: 40,
  fill: "var(--hop-neutral-border-weak)",
  rx: 2
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 32.935,
  height: 4,
  x: 76.73,
  y: 69.752,
  fill: "var(--hop-neutral-surface)",
  rx: 2
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 82,
  height: 4,
  x: 10.257,
  y: 10.248,
  fill: "var(--hop-neutral-border-weak)",
  rx: 2
})));
export default SvgForm;